import { lazy, Suspense } from 'react';

const LazyRegisterTemp = lazy(() => import('./RegisterTemp'));

const RegisterTemp = () => (
  <Suspense fallback={null}>
    <LazyRegisterTemp />
  </Suspense>
);

export default RegisterTemp;
